import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { SocialLink } from '../social-link/social-link.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @HostBinding('class') get addClasses() {
    return `dp:blk`;
  }

  socialLinks: SocialLink[] = [
    {
      uniqueID: 'Contact',
      href: 'mailto:oscarsaca88@gmail.com',
      dataTip: "Let's Chat :)",
      svgPath:
        'M0 4.506L36 4.506L36 31.494L0 31.494L0 4.506ZM30.062 7.88L5.937 7.88L17.999 17.549L30.062 7.88ZM3.272 10.015L3.272 28.121L32.726 28.121L32.726 10.015L17.999 21.824L3.272 10.015Z',
      target: '_self',
    },
    {
      uniqueID: 'Linkedin',
      href: 'https://www.linkedin.com/in/oscar-saca',
      dataTip: 'Professional',
      svgPath:
        'M4.286 1.688C1.695 1.688 0 3.347 0 5.536C0 7.684 1.647 9.378 4.187 9.378L4.238 9.378C6.875 9.378 8.517 7.677 8.517 5.529C8.467 3.342 6.875 1.688 4.286 1.688ZM27.096 11.936C23.076 11.936 20.557 14.106 20.091 15.627L20.091 12.149L12.208 12.149C12.311 13.996 12.208 34.312 12.208 34.312L20.091 34.312L20.091 22.319C20.091 21.653 20.06 20.986 20.262 20.508C20.805 19.176 21.969 17.792 24.063 17.792C26.799 17.792 28.044 19.842 28.044 22.843L28.044 34.312L36 34.312L36 21.989C36 15.125 32.082 11.936 27.096 11.936ZM0.908 12.15L0.908 34.312L7.924 34.312L7.924 12.15L0.908 12.15Z',
      target: '_blank',
    },
    {
      uniqueID: 'GitHub',
      href: 'https://github.com/oscarsaca',
      dataTip: 'Some Code',
      svgPath:
        'M18 0C8.061 0 0 8.061 0 18c0 7.956 5.157 14.699 12.312 17.079c0.9 0.165 1.227-0.39 1.227-0.865c0-0.429-0.018-1.849-0.025-3.35c-5.006 1.086-6.064-2.123-6.064-2.123c-0.819-2.078-1.997-2.633-1.997-2.633c-1.635-1.118 0.123-1.093 0.123-1.093c1.807 0.127 2.76 1.856 2.76 1.856c1.607 2.753 4.215 1.955 5.238 1.494c0.165-1.16 0.629-1.955 1.143-2.405c-3.997-0.454-8.198-2-8.198-8.898c0-1.965 0.703-3.572 1.853-4.83c-0.183-0.457-0.802-2.289 0.179-4.767c0 0 1.508-0.485 4.95 1.846c1.434-0.401 2.974-0.598 4.504-0.605c1.529 0.007 3.069 0.207 4.507 0.608c3.435-2.331 4.946-1.846 4.946-1.846c0.984 2.479 0.366 4.31 0.179 4.764c1.153 1.259 1.849 2.865 1.849 4.83c0 6.915-4.212 8.438-8.22 8.884c0.647 0.559 1.223 1.652 1.223 3.333c0 2.405-0.025 4.345-0.025 4.939c0 0.478 0.327 1.041 1.241 0.865C30.846 32.695 36 25.949 36 18C36 8.061 27.942 0 18 0z',
      target: '_blank',
    },
  ];
}
